export default __webpack_public_path__ + "static/clothes-fc82e9c96a95dabd7dede47b494010a4.png";